import moment from 'moment';

export const NEXT_UPDATE_KEY = 'controller.v2tournaments.next_update';

// Params come raw from the API (ISO8601 `time`, integer seconds `in`);
// `time` is formatted with the league's hour format before interpolation.
const formatMessage = ({ key, params }, timeFormat) => {
  if (!window.I18n) return '';

  const options = { ...(params || {}) };
  if (options.time) options.time = moment(options.time).format(timeFormat);

  return window.I18n.t(key, options);
};

// Without window.I18n the keys cannot be translated — return '' so callers
// leave the server-rendered status untouched.
export const formatScoringStatusText = (messages, timeFormat) => {
  if (!window.I18n || !Array.isArray(messages)) return '';

  return messages.map((message) => formatMessage(message, timeFormat)).join('').trim();
};

// The next scheduled scoring run, in milliseconds from now, or null when the
// status carries no countdown.
export const nextUpdateDelayMs = (messages) => {
  const seconds = messages?.find((message) => message.key === NEXT_UPDATE_KEY)?.params?.in;

  return Number.isFinite(seconds) && seconds > 0 ? seconds * 1000 : null;
};

// Change-detection fingerprint. The countdown param (`in`) is excluded: it
// decreases on every poll and would otherwise read as a change each time.
export const comparableScoringStatus = (messages) =>
  JSON.stringify((messages || []).map(({ key, params }) => [key, params?.time ?? null]));
